import React, { Component } from 'react';
import 'react-select/dist/react-select.css';
import './InputSelect.css';
import 'whatwg-fetch';
import getLabel from '../../translations/messages';
import PropTypes from 'prop-types';
import { classNames } from '../../functions/classNames';


class RemoteInputNumber extends Component {

 handleChange = (e, format, delegate) => {
	  if (format !== undefined && e.target.value.trim() !== '' && !format.test(e.target.value)) {
	    return;
	  }

	  delegate(e);
	};
	

  getLabel = (data, localize, locale, optionLabelName) => {
    if (Array.isArray(optionLabelName)) {
      return optionLabelName.map(l => data[l]).join(' - ');

    }

    return localize ? getLabel(locale, localize + '.' + data[optionLabelName]) : data[optionLabelName];

  };


  render() {

    return (
      <div
        className={classNames('InputNumber', this.props.error ? 'hasError' : '')}
        style={this.props.style}
        name={this.props.name + '-component'}
      >
        <div className="inputLabel">
          <span>{getLabel(this.context.locale, this.props.label)}</span>
          {this.props.required ? <span className="required">*</span> : ''}
        </div>
	    <input
	      type="number"
	      name={this.props.name}
	      value={this.props.value}
	      onChange={(e) => this.handleChange(e, this.props.format, this.props.handleChange)}
	      placeholder={this.props.placeholder ? this.props.placeholder : ''}
	      autoComplete="off"
	    />
      </div>
    );
  }

}

RemoteInputNumber.contextTypes = {
  locale: PropTypes.string,
};

export default RemoteInputNumber;



// WEBPACK FOOTER //
// ./src/main/components/input/RemoteInputNumber.js